import { atom } from 'jotai';

export type MarketGoodsListFilter = {
  sort: string;
  keyword: string;
  categorySno: number | null;
  subCategorySno: number | null;
  deliveryType: string | null;
};
export const marketGoodsListFilterAtom = atom<{
  [marketId: number]: MarketGoodsListFilter;
}>({});

export const marketGoodsCategoriesFilterAtom = atom<{
  [marketId: number]: {
    showSearch: boolean;
    keyword: string;
  };
}>({});
